<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label-width="0px">
                <el-row>
                  <el-col>
                    <el-form-item label="접수기간">
                      <el-col :span="10">
                        <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                      <el-col :span="1" style="text-align: start;">-</el-col>
                      <el-col :span="10">
                        <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="처리결과" label-width="100px">
                <el-col :span="16">
                  <el-select v-model="form.callStatus">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['callStatus']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="접수상담원" label-width="110px">
                <el-select v-model="form.userEmpSelAll">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['userEmpSelAll']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="상담유형">
                <el-select v-model="form.callClass" @change="onCallClassChange0">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in callClassOpt"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="상담분류" label-width="134px">
                <el-select v-model="form.callCatId1" placeholder="상담분류(대)" @change="onCallClassChange1">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in callCatIdOpt1"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label=" " label-width="10px">
                <el-select v-model="form.callCatId2" placeholder="상담분류(중)" @change="onCallClassChange2">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                    v-for="item in callCatIdOpt2"
                    :key="item.value"
                    :label="item.value"
                    :value="item.key">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label=" " label-width="10px">
                <el-select v-model="form.callCatId3" placeholder="상담분류(소)"  @change="onCallClassChange3">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                    v-for="item in callCatIdOpt3"
                    :key="item.value"
                    :label="item.value"
                    :value="item.key">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
             
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="고객구분">
                <el-select v-model="form.custType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['custType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item :label="$i18n.messages[$store.state.locale].siteNm" label-width="134px">
                <el-row>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm1" @keyup.native.enter="goOpen"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm2" @keyup.native.enter="goOpen"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm3" @keyup.native.enter="goOpen"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal_01 from "@/components/AS/History/Modal/ReceptionModal_01";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}


export default {
  props: {
  },
  data() {
    return {
      data: [],
      form: {
        companyId : '',
        startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        callType: '',
        siteType: '',
        catId: 0,
        creatorId: 0,
        callStatus: '',             // 처리결과
        userEmpSelAll: '',          // 접수상담원
        callClass : '',             // 상담유형
        callCatId1 : '',            // 상담분류
        callCatId2 : '',            // 상담분류
        callCatId3 : '',            // 상담분류
        custType : '',             // 고객구분
        siteNm1 : '',              // 사이트명1
        siteNm2 : '',              // 사이트명2
        siteNm3 : '',              // 사이트명3
        sortType :  '',
        processTime : '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime: ''
      },
      combos: {
        'callStatus': [],
        'userEmpSelAll' : [],
        'callCat' : [],
        'custType' : []
      },
      callClassOpt:[], /** 상담유형리스트 */
      callClassIdOpt: [], /** 상담유형리스트 Id */
      callCatIdOpt1:[],
      callCatIdOpt2:[],
      callCatIdOpt3:[],
      startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
      endDt: this.$moment().format('YYYY-MM-DD'),
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter: true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:50,
          cellStyle:{textAlign: 'center'}
        },
        {headerName:'접수일시', field:'callDt', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'상담유형', field:'catFullNm0', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'상담분류1', field:'catFullNm1', width:100, cellStyle:{textAlign: 'left'}},
        {headerName:'상담분류2', field:'catFullNm2', width:100, cellStyle:{textAlign: 'left'}},
        {headerName:'상담분류3', field:'catFullNm3', width:100, cellStyle:{textAlign: 'left'}},
        {headerName:'상담분류4', field:'catFullNm4', width:100, cellStyle:{textAlign: 'left'}},
        {headerName:'고객구분', field:'custType', width:100},
        {headerName:'사이트명', field:'siteNm1', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'신고자명', field:'boundCustNm', width:130, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }},
        {headerName:'유입전화번호', field:'boundTelNo', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'문의내역', field:'question', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'상담내역', field:'answer', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'제조사', field:'makerNm', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'modelGroupNm', width:80, cellStyle:{textAlign: 'center'}},
        {headerName:'대표모델', field:'standardModelNm', width:80, cellStyle:{textAlign: 'center'}},
        {headerName:'모델', field:'modelNm', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'접수자', field:'creatorNm', width:80, cellStyle:{textAlign: 'center'}},
        {headerName:'수정자', field:'updatorNm', width:80, cellStyle:{textAlign: 'center'}},
        {headerName:'처리결과', field:'callTypeNm', width:80, cellStyle:{textAlign: 'center'}},
        {headerName:'처리시간', field:'createDt', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'CALL_ID', field:'callId', width:50, cellStyle:{textAlign: 'center'}, hide: true}
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      console.log('onCellClicked params : ', params)
      if(field === 'boundCustNm') {
        this.$router.push({          
                path: '/callMain',
                query: {
                  CALL_ID : params.data.callId,
                }
            })    
      }
    },
    
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      let that = this
      this.form.catId = 0
      if(this.form.callCatId3 !== ''){
        this.form.catId = this.form.callCatId3
      } else if(this.form.callCatId2 !== ''){
        this.form.catId = this.form.callCatId2
      } else if(this.form.callCatId1 !== ''){
        this.form.catId = this.form.callCatId1
      } else if(this.form.callClass !== ''){
        this.form.catId = this.form.callClass
      }
      
      const aEmpKey = this.form.userEmpSelAll.split(',');
      if(aEmpKey && aEmpKey.length>0){
        this.form.creatorId = aEmpKey[1] || '0';
      } else {
        this.form.creatorId = '0';
      }

      this.form.siteType = this.form.custType === '' ? '' : this.form.custType
      
      let vForm = _.cloneDeep(this.form);
      if(vForm && (vForm.startDt == null || vForm.startDt == '')){
        vForm.startDt = '2000-01-01';
      }

      if(vForm && (vForm.endDt == null || vForm.endDt == '')){
        vForm.endDt = '2100-12-31';
      }

      console.log('goOpen passed vForm: ', vForm);
      this.$store.commit('loading');

      this.$http.post(_url("/api/asMng/callList/list"), vForm).then(response => {
        console.log('response.data' , response.data)
        this.data = response.data.map((x,index)=>{
          x.no = index+1;
          const vObj = this.combos['custType'].filter(y=>y.key === x.custType).map(z=>{return z.value}) ;
          x.custType = vObj && vObj.length>0 ? vObj[0] : '';
          x.boundTelNo = _phone(x.boundTelNo);
          x.callDt = x.callDt && x.callDt.length>=19 ? x.callDt.substring(0,19) : '';
          x.createDt = x.createDt && x.createDt.length>=19 ? x.createDt.substring(0,19) : '';
          
          if(x.catFullNm){
            const aCatFullNmObj = (x.catFullNm).split('>');
            if(aCatFullNmObj && aCatFullNmObj.length > 0){
              x.catFullNm0 = aCatFullNmObj.length >=1 ? aCatFullNmObj[0] : '';
              x.catFullNm1 = aCatFullNmObj.length >=1 ? aCatFullNmObj[1] : '';
              x.catFullNm2 = aCatFullNmObj.length >=2 ? aCatFullNmObj[2] : '';
              x.catFullNm3 = aCatFullNmObj.length >=3 ? aCatFullNmObj[3] : '';
              x.catFullNm4 = aCatFullNmObj.length >=4 ? aCatFullNmObj[4] : '';
            }
          }
          
          return x;
        })

      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/asMng/callList/init`)
          .then(response => {
            
            this.combos['callStatus'] = response.data.callType.map(x=>{const vobj={key:x.catValue1, value:x.catNm}; return vobj; }); // 처리결과
            this.callClassOpt = response.data.callCat;
            this.callClassIdOpt = response.data.callCatId;
            this.combos['custType'] = response.data.custType;
            this.combos['userEmpSelAll'] = response.data.userEmpSelAll;
            
            this.form.callStatus = 'Receipt'

            if(this.$store.state.loginInfo.groupUId==3 || this.$store.state.loginInfo.groupUId==6) {
              this.form.userEmpSelAll = this.$store.state.loginInfo.loginId + ',' + this.$store.state.loginInfo.id;
            } 

          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
    },
    onCallClassChange0(value){

      // 초기화
      // 상담분류(대)
      this.callCatIdOpt1 = JSON.parse(JSON.stringify([]))
      this.callCatIdIdOpt1 = JSON.parse(JSON.stringify([]))
      this.form.callCatId1 = ''

      if(this.form.callClass != '') { // 상담유형이 공백이 아닌 경우
          const vIdx = this.callClassOpt.findIndex(x=>x.key === value)
          const vParentId = this.callClassIdOpt[vIdx].key || 0

          this.getCombo({flag: 'CHG0', parentId: vParentId})
          this.form.catId = vParentId
      }

      // 초기화
      this.callCatIdOpt2 = JSON.parse(JSON.stringify([]))
      this.callCatIdIdOpt2 = JSON.parse(JSON.stringify([]))
      this.form.callCatId2 = ''
      this.callCatIdOpt3 = JSON.parse(JSON.stringify([]))
      this.callCatIdIdOpt3 = JSON.parse(JSON.stringify([]))
      this.form.callCatId3 = ''

    },
    onCallClassChange1(value){

      // 초기화

      this.callCatIdOpt2 = JSON.parse(JSON.stringify([]))
      this.callCatIdIdOpt2 = JSON.parse(JSON.stringify([]))
      this.form.callCatId2 = ''

      if(this.form.callCatId1 != '') {
          const vIdx = this.callCatIdOpt1.findIndex(x=>x.key === value)
          const vParentId = this.callCatIdIdOpt1[vIdx].key || 0

          this.getCombo({flag: 'CHG1', parentId: vParentId})
          this.form.catId = vParentId
      }

      // 초기화
      this.callCatIdOpt3 = JSON.parse(JSON.stringify([]))
      this.callCatIdIdOpt3 = JSON.parse(JSON.stringify([]))
      this.form.callCatId3 = ''
    },
    onCallClassChange2(value){

      const vIdx = this.callCatIdOpt2.findIndex(x=>x.key === value)
      const vParentId = this.callCatIdIdOpt2[vIdx].key || 0

      this.getCombo({flag: 'CHG2', parentId: vParentId})
      this.form.catId = vParentId
    },
    onCallClassChange3(value){

      const vIdx = this.callCatIdOpt3.findIndex(x=>x.key === value)
      const vParentId = this.callCatIdIdOpt3[vIdx].key || 0
      
      this.form.catId = vParentId
    },
    getCombo(param){
      if(param.flag === 'CHG0'){
console.log(' getCombo CHG0 :', param)
            // 상담분류(대)
            this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                .then(response => {
                    this.callCatIdOpt1 = _.cloneDeep(response.data) || []
                    this.form.callCatId = ''
                });
            this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                .then(response => {
                    this.callCatIdIdOpt1 = _.cloneDeep(response.data) || []
                   
            });   

        }else if(param.flag === 'CHG1'){

            // 상담분류(대)
            this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                .then(response => {
                    this.callCatIdOpt2 = _.cloneDeep(response.data) || []
                    this.form.callCatId2 = ''
                });
            this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                .then(response => {
                    this.callCatIdIdOpt2 = _.cloneDeep(response.data) || []
                    
            });    
        }else if(param.flag === 'CHG2'){

            // 상담분류(대)
            this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                .then(response => {
                    this.callCatIdOpt3 = _.cloneDeep(response.data) || []
                    this.form.callCatId3 = ''
                }); 
            this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                .then(response => {
                    this.callCatIdIdOpt3 = _.cloneDeep(response.data) || []
                });    
        }
    }

  },
  created() {

    if(this.$route.query.startDt == 'TodayComplete'){
      this.form.startDt = this.$moment().format('YYYY-MM-DD');
    }else if(this.$route.query.startDt == 'TodayWork'){
      this.form.startDt = '';
    }

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>